import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{attrs:{"padless":""}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("NIXAP DEVELOPMENT")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }